export default __webpack_public_path__ + "static/media/Redo.4690dcbf.svg";